export default     {
    prompt:"Episode Background?",
    field:"episodeBackground",
    type:"childStyle",
    child:".short-cont",
    valueType:"string",
    colorPicker:true,
    default:"inherit",
    property:"background"
}